var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formButton"},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.itemRender.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }